import { delegate } from '@js/util/delegate.js'

document.addEventListener('click', delegate('[data-open-modal]', e => {
  const modalId = e.target.closest('[data-open-modal]').dataset.openModal;
  const modal = document.querySelector(`#${modalId}`);

  if(!modal) {
    return;
  }

  modal.showModal();
  modal.dispatchEvent(new CustomEvent('modalOpen', {
    bubbles: true,
    detail: {
      modal,
    }
  }));
}))
